<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>配送料設定</span>
            </div>
            <div class="headerRightMenu">
                <Button @click="openCreateModal">新規追加</Button>
            </div>
        </div>

        <ul class="list">
            <template v-for="ds in this.delivery_sizes">
                <li class="info" v-bind:key="ds.id">
                    <div class="infoLeft">
                        <h3><span>【{{ ds.id }}】</span>{{ ds.text }}</h3>
                        <p>配送料 : {{ ds.price | priceLocaleString }}</p>
                        <p>FBA配送料 : {{ ds.fba_price | priceLocaleString }}</p>
                    </div>
                    <div class="infoRight">
                        <Button class="btn" @click="openUpdateModal(ds.id)">編集</Button>
                    </div>
                </li>
            </template>
        </ul>
        <div class="listFooter">
        </div>
        <modal name="deliverySizeModal" :draggable="false" :resizable="false" width="80%" height="90%">
            <DeliverySizeModal :deliverySizeId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('deliverySizeModal')" />
        </modal>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>


    </div>
</template>

<script>
import DeliverySizeModal from '../components/DeliverySizeModal.vue'

export default {
    components: {
        DeliverySizeModal,
    },
    data() {
        return {
            statusMessage: "",
            delivery_sizes: {},
            selectedId: null,
            createMode: true,
        }
    },
    mounted: function () {
        this.getDeliverySizes();
    },
    methods: {
        getDeliverySizes: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/deliverySizes")
                .then((res) => {
                    this.delivery_sizes = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        openCreateModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('deliverySizeModal');
        },
        openUpdateModal: function (id) {
            this.selectedId = id;
            this.createMode = false;
            this.$modal.show('deliverySizeModal');
        },
        modalClosed(modalName) {
            this.getDeliverySizes();
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.$modal.hide(modalName)

        },

    },
    computed: {
    }
}
</script>

<style scoped lang="sass">
.containerInner
    display: inline-grid
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
        .headerRightMenu
            flex: 1 0 auto
            span
                display: inline-block
                text-align: left
                vertical-align: middle
                .addBtn, .adsetUpdateBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 170px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
    .list
        background: $whiteColor
        font-size: 1.2rem
        margin: 10px 140px 0 140px
        overflow-y: scroll
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            padding: 10px
            .btn
                width: 100px
                margin-left: 20px
                margin-bottom: 8px
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                h3
                    font-size: 1.5rem
                    font-weight: 700
                    margin-bottom: 10px
                p
                    margin: 0 0 10px 20px
                    font-size: 1.4rem
                    display: flex
                .name
                    font-weight: 700
                .description
                    margin-left: 16px
                .inputText
                    margin-left: 10px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        display: flex
        justify-content: center
        .updateBtn
            width: 80px

    .deliverySizeModal
        display: none;
    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 20px 0 0 10px
            .headerRightMenu
                margin-top: 10px
        .list
            margin: 10px 0 0
</style>
